/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomComponentsResponse {
    getFixupPrototypeFunction() { return AppSecopsSbomComponentsResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomComponentsResponse>): AppSecopsSbomComponentsResponse {
        let obj = Object.assign(new AppSecopsSbomComponentsResponse(), model);
        AppSecopsSbomComponentsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomComponentsResponse>): AppSecopsSbomComponentsResponse {
        if (!model) return null;
        return AppSecopsSbomComponentsResponse.newInstance(<AppSecopsSbomComponentsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomComponentsResponse) {
        if (!obj) return;

        models.AppSecopsSbomComponentsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomComponentsResponse): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomComponentsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.results) {
            for (let val of this.results) {
                models.AppSecopsSbomComponentDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<models.AppSecopsSbomComponentDetails>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
